import { Model as a } from "../../../../../model.js";
class t extends a {
  constructor(o) {
    super(), this.corpLogo = o.corpLogo, this.currencyLogo = o.currencyLogo, this.cardBackgroundImage = o.cardBackgroundImage, this.progressBarColor = o.progressBarColor, this.balanceBackgroundColor = o.balanceBackgroundColor, this.labelLevelName = o.labelLevelName, this.labelCustomerName = o.labelCustomerName, this.labelRewardName = o.labelRewardName, this.balanceProgressVisibility = o.balanceProgressVisibility, this.font = o.font, this.highlightColor = o.highlightColor, this.backgroundColor = o.backgroundColor, this.cardColor = o.cardColor, this.stampsColor = o.stampsColor, this.contentTextColor = o.contentTextColor, this.texts = o.texts;
  }
}
export {
  t as TierDesignModel
};
//# sourceMappingURL=tierDesign.model.js.map
